import { Component, OnInit, Input } from '@angular/core';
import { SolicitacaoService } from 'src/app/service/solicitacao/solicitacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'servicos-acoes-adm-solicitacao',
  templateUrl: './servicos-acoes-adm-solicitacao.component.html',
  styleUrls: ['./servicos-acoes-adm-solicitacao.component.css']
})
export class ServicosAcoesAdmSolicitacaoComponent implements OnInit {

  @Input() visualizacao: boolean;
  listaClassificacaoComponente = [];
  charNum = 5000;

  constructor(
    public service: SolicitacaoService,
    private desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) { }

  ngOnInit() {
    this.preencherListaClassificacao();
  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.solicitacao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.solicitacao.value.assunto.id);
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarOutrasOpcoes(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.solicitacao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.solicitacao.controls[str].touched &&
      this.service.solicitacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

}
